import { Typography } from "@mui/material";
import { UseFormGetValues } from "react-hook-form";
import {useGetShippingQuery} from "@/redux-store/api/marketingApi.ts";

interface IProps {
  getValues: UseFormGetValues<ICheckoutForm>;
}

const SecondStepSummary: React.FC<IProps> = ({ getValues }) => {
  const { data } = useGetShippingQuery({});

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const chosenShipping = data?.find(
    (option: { id: string | number; }) => getValues().shippingMethod == option.id
  );
  const label = chosenShipping
    ? `${chosenShipping.name} ${
        chosenShipping.price ? chosenShipping.price : ""
      }`
    : "";

  return (
    <Typography
      variant="subtitle1"
      fontWeight={{ xs: 500, md: 600 }}
      color="text.secondary"
    >
      {label}
    </Typography>
  );
};

export default SecondStepSummary;
